import { useGetSalesBonusReport } from 'api-hooks/report';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import PivotReportTemplate from './components/pivot-report-template';

export default function SalesBonusReport() {
  const { t } = useTranslation();

  return (
    <PivotReportTemplate
      usePivotQuery={useGetSalesBonusReport}
      title={t('common:sales-bonus-report')}
      completeName={['bonus_period', 'employee']}
    />
  );
}
